export default __webpack_public_path__ + "static/media/icon3.972c6cdc.png";